import styled from "styled-components";
import { theme } from "../../styles/theme";

export const ContainerPlanos = styled.div`
    background-color: #FFFFFF;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: flex-start;
    padding-left: 40px;
    padding-right: 40px;
    padding-bottom: 30px;
    padding-top: 30px;

    @media only screen and (max-width: 768px) {
        padding-left: 8px;
        padding-right: 8px;
        padding-bottom: 8px;
    }
`;

export const Tela = styled.div`
    width: 100vw;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

`;

export const SimulaPlanos = styled.div`
    background-color: #FFFFFF;
    width: 40%;
   
    .container{
        width: 420px;
        margin: auto;

        .valores{
            margin-top: 40px;
            .valor{
                text-align: center;
                font-family: Lato;
                font-weight: normal;
                font-size: 23px;
                font-stretch: normal;
                font-style: normal;
                line-height: normal;
                letter-spacing: normal;
                color: #8a92a2;
            }
            .total{
                text-align: center;
                font-family: Lato;
                font-weight: normal;
                font-size: 12px;
                font-stretch: normal;
                font-style: normal;
                line-height: normal;
                letter-spacing: normal;
                color: #8a92a2;

            }
        }

        .botoes{
            display: flex;
            flex-direction: row;
            justify-content: space-around;
            flex-wrap: wrap;
            margin-top: 60px;
            width: 100%;
            max-width: 400px;
            button{
                margin-bottom: 20px;
            }
        }


    }
    @media only screen and (max-width: 768px){
        width: 100%;

        .button-finish {
            justify-content: space-evenly !important;
        }

        .logo{
            position: absolute;
            left: 0;
            right: 0;
            margin: auto;
            img{
                margin-left: 15px;
            }
        }

    }

    @media only screen and (max-width: 440px){
        .container{
            width: 100%;
        }

    }

`;

export const Footer = styled.div`
    width: 100%;
    position: absolute;
    bottom: 0;
    background-color: ${theme.colors.gray.Cinza_2};
    margin-top: 31px;

    .contatos{
        width: 580px;
        margin: auto;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-around;
        color: #FFF;
        padding-top: 10px;
        padding-bottom: 10px;

        .item{
            margin-left: 20px;
            display: flex;
            flex-direction: row;
            a{
                text-decoration: none;
                color: #FFF;
                img{
                    width: 20px;
                }
                i{
                    font-size: 14px;
                    position: relative;
                    top: 2  px;
                    margin-right: 5px;
                }
            }
            i{
                font-size: 14px;
                position: relative;
                top: 5px;
                margin-right: 5px;
            }
        }
    }


    @media only screen and (max-height: 667px){
        position: relative;
        .contatos{
            width: 90%;
            max-width: 580px;
        }
    }

`;

export const Container = styled.div`
    width: 100%;
    max-width: 440px;
    margin: auto;
    height: auto;
    margin-top: ${props => props.marginTop ? props.marginTop : '48px'};
    padding: 0px 16px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .text {
        font-size: 13px;
        text-align: center;
        letter-spacing: 0px;
    }
`;

export const Title = styled.h2`
    font-family: Lato;
    font-size: 1.5rem;
    font-weight: 800;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.95rem;
    letter-spacing: 0;
    color: ${theme.colors.gray.Cinza_2};
    text-align: center;
    margin-bottom: ${props => props.marginBottom ? props.marginBottom : '16px'};
    margin-top: ${props => props.marginTop ? props.marginTop : '0px'};
`;

export const Subtitle = styled.label`
    font-family: Lato;
    font-size: 11px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: ${theme.colors.gray.Cinza_2};
    margin-top: 8px;
`;

export const ModalWide = styled.div`
    width: 100%;
    max-width: 100%;
    margin: auto;
    height: auto;
    margin-top: ${props => props.marginTop ? props.marginTop : '48px'};
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const ModalStack = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
`;

export const ModalIntro = styled.p`
    width: 100%;
    font-family: Lato;
    font-size: 12px;
    text-align: center;
    color: ${theme.colors.gray.Cinza_2};
    margin: 0px;
`;

export const NewValueSummary = styled.p`
    width: 100%;
    font-family: Lato;
    font-size: 12px;
    font-weight: bold;
    text-align: center;
    color: ${theme.colors.gray.Cinza_2};
    margin: 0px;
`;

export const CompareTable = styled.div`
    width: 100%;
    margin: 0px;
`;

export const CompareHeaderRow = styled.div`
    width: 100%;
    padding-bottom: 16px;

    gap: 8px;
    display: grid;
    grid-template-columns: 1fr 1.3fr 1fr;
    
    border-bottom: 1px solid ${theme.colors.gray.Cinza_11};

    span {
        font-family: Lato;
        font-size: 12px;
        font-weight: bold;
        letter-spacing: 0.4px;
        text-transform: uppercase;
        color: ${theme.colors.gray.Cinza_2};
    }

    span:nth-child(1) {
        text-align: left;
    }

    span:nth-child(2) {
        text-align: center;
    }

    span:nth-child(3) {
        text-align: right;
    }

    @media only screen and (max-width: 420px) {
        grid-template-columns: 1fr 1fr 1fr;
    }
`;

export const CompareRow = styled.div`
    width: 100%;
    padding: 16px 0px;

    gap: 8px;
    display: grid;
    align-items: center;
    grid-template-columns: 1fr 1.3fr 1fr;
    
    border-bottom: 1px solid ${theme.colors.gray.Cinza_11};

    > div:nth-child(1) {
        justify-self: start;
    }

    > div:nth-child(2) {
        justify-self: center;
    }

    @media only screen and (max-width: 420px) {
        grid-template-columns: 1fr 1fr 1fr;
    }
`;

export const CompareLabel = styled.div`
    width: 100%;

    text-align: left;
    font-family: Lato;
    font-size: 16px;
    font-weight: ${props => props.bold ? 'bold' : 'normal'};
    color: ${theme.colors.gray.Cinza_2};

    small {
        display: block;
        text-align: left;
        font-size: 12px;
        font-weight: normal;
        color: ${theme.colors.gray.Cinza_2};
        margin-top: 2px;
    }

    @media only screen and (max-width: 479px) {
        font-size: 12px;
    }
`;

export const NumericBoxWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;

    small {
        font-family: Lato;
        font-size: 12px;
        color: ${theme.colors.gray.Cinza_2};
        text-align: center;
    }
`;

export const DeltaQty = styled.div`
    text-align: center;
    font-family: Lato;
    font-size: 16px;
    font-weight: bold;
    color: ${theme.colors.gray.Cinza_2};
`;

export const DeltaValue = styled.div`
    text-align: right;
    font-family: Lato;
    font-size: 16px;
    font-weight: bold;
    color: ${theme.colors.gray.Cinza_2};

    @media only screen and (max-width: 479px) {
        font-size: 12px;
    }
`;

export const ProrationNote = styled.p`
    width: 100%;

    font-family: Lato;
    font-size: 12px;
    line-height: 1.5;
    text-align: center;
    color: ${theme.colors.gray.Cinza_2};
    margin: 0px;
`;

export const ModalButtonsRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    flex-wrap: wrap;
    margin: 0px;
`;

export const HeaderPlans = styled.div`
    width: 100%;
    max-width: 1100px;
    
    display: flex;
    margin-inline: 0;
    align-items: center;
    justify-content: space-between;
    
    background-color: #FFFFFF;

    .image {
        width: 100%;
        max-width: 255px;
        
        img {
            width: 10.625rem;
            height: 2.375rem;
        }
    }

    .links {
        width: 100%;
        max-width: 255px;

        gap: 1.5rem;
        display: flex;

        font-size: 0.625rem;
        text-transform: uppercase;
        font-weight: 700;
        letter-spacing: 0.1rem;
        justify-content: center;
        
        a {
            color: ${theme.colors.gray.Cinza_2};
            padding: 0.7rem;
            border-radius: 1rem;
            transition: background-color 300ms ease;
        
            &:hover {
                background-color: lightgray;

            }
        }
    }

    .buttons-plans {
        display: flex;
        gap: 10px;

        > :nth-child(1){
            all: unset;
            cursor: pointer;
            background-color: #FFFFFF;
            padding: 12px 24px;
            border: 2px solid ${theme.colors.gray.Cinza_2};
            border-radius: 50px;
            font-size: 11px;
            letter-spacing: 0.1rem;
            font-weight: 800;
            text-transform: uppercase;
            color: ${theme.colors.gray.Cinza_2};
            transition: scale 500ms ease;
            
            &:hover {
                scale: 1.1;
                color: #FFFFFF;
                background-color: ${theme.colors.gray.Cinza_2};
            }
        }

        > :nth-child(2){
            all: unset;
            cursor: pointer;
            background-color: #2FBB69;
            padding: 16px 24px 16px 24px;
            border-radius: 50px;
            font-size: 11px;
            letter-spacing: 0.1rem;
            font-weight: 800;
            text-transform: uppercase;
            color: white;
            transition: scale 500ms ease;

            &:hover {
                scale: 1.1;
            }
        }
    }

    .mobile-only {
        display: none;
    }

    @media (max-width: 911px) {
        justify-content: space-between;
        padding: 1rem;

        .buttons-plans {
            display: none;
        }

        .links {
            display: none;
        }

        .mobile-only {
            display: flex;
            gap: 12px;
            letter-spacing: 0.1rem;
            font-size: 10px;
            text-transform: uppercase;

            a {
                color: ${theme.colors.gray.Cinza_2};
                cursor: pointer;
            }
        }
    }
`